import React, { useTransition } from 'react';
import Button from '@atoms/Button/Button';
import DialogContent from './DialogContent';
import DialogFooter from './DialogFooter';
import DialogFullHeader from './DialogFullHeader';
import { useTranslation } from 'react-i18next';

interface Props {
    children: React.ReactNode;
    title?: string;
    hideModal: VoidFunction;
}

const InfoDialog: React.FC<Props> = ({ children, title, hideModal }) => {
    const { t: translate } = useTranslation();

    return (
        <>
            {title && (
                <DialogFullHeader
                    title={title}
                    onCloseButtonClick={hideModal}
                />
            )}
            <DialogContent>{children}</DialogContent>
            <DialogFooter>
                <Button
                    align="center"
                    label={translate('button.back')}
                    onClick={hideModal}
                />
            </DialogFooter>
        </>
    );
};

export default InfoDialog;
